export enum SelectionMode {
  /** Always replaces the current selection with the new selection */
  SingleSelect = 0,
  /** Adds new selections to the current selection */
  MultiSelect = 1,
}